export const piForm = {
  services_which_you_use: "აირჩიე ანგარიშის გახსნის მიზანი",
  exp_monthly_turnovers_in_gel: "ყოველთვიური ბრუნვების ოდენობა ლარში",
  settlement_countries: "ანგარიშსწორების ქვეყნები",
  tax_payer: "აშშ-ს მწვანე ბარათი ხომ არ გაქვს?",
  fatca_street_placeholder: "ქალაქი, შტატი და საფოსტო ინდექსი",
  please_specify_one_or_both:
    "მონიშნეთ მითითებული ველებიდან ერთ-ერთი, ან ორივე",
  fatca_federal_tax:
    "მონიშნეთ ფედერალური საგადასახადო კლასიფიკაციის შესაბამისი უჯრა:",
  privacy_of_fatca:
    "წინამდებარე დოკუმენტზე გამოვხატავ თანხმობას ჩემი პერსონალური მონაცემების დამუშავებაზე FATCA-ს რეგულაციებისა და მიზნების შესაბამისად.",
  usaTaxPayer: "აშშ-ს გადასახადის გადამხდელი",
  fatca_TIN: "შეიყვანე TIN ნომერი",
  fatca_TIN_description:
    "შეიყვანეთ თქვენი გადამხდელის საიდენტიფიკაციო  ნომერი (TIN) შესაბამის ველში. გადახდის წყაროსთან საშემოსავლო გადასახადის ორჯერ დაკავების  თავიდან აცილების მიზნით, მითითებული TIN უნდა შეესაბამებოდეს „სახელის“ ველში მითითებულ სახელს. ფიზიკური პირებისათვის, ეს არის თქვენი სოციალური უზრუნველყოფის ნომერი (SSN). სხვა პირებისთვის, ეს არის თქვენი დამსაქმებლის საიდენტიფიკაციო ნომერი (EIN).",
  pep_montly_turnovers_title: "მოსალოდნელი ჯამური თვიური ბრუნვა ანგარიშზე",
  pep_estimated_cash_turnover: "აირჩიე ანგარიშზე განსათავსებელი თანხის წყარო",
  pep_SourceOfCashFunds: "აირჩიე ნაღდი ფულის  ყოველთვიური ბრუნვა ანგარიშზე ",
  pep_sourceOfProperty: "მონიშნე ქონების წარმომავლობა",
  pep_informationRegardingAssets: "მონიშნე რა არის შენს საკუთრებაში",
  pep_categoryOfPoliticalyExposedPerson:
    "მიეკუთვნები პოლიტიკურად აქტიური პირის კატეგორიას ან ხარ დაკაშირებული პოლიტიკურად აქტიურ პირთან?",
  kyc_categoryOfPoliticalyExposedPersonInfo:
    "თქვენ ან თქვენი ოჯახის წევრი მიეკუთვნებით პოლიტიკურად აქტიური პირის კატეგორიას?",
  mailingAddress: "საფოსტო ინდექსი",
  pep_position: "თანამდებობა",
  fatca_tinnumber_length_validation: "ჩაწერეთ ცხრა სიმბოლო",
  pi_kyc_table_header: "ქონების / ფულადი სახსრების წყაროს აღწერა",
  kyc_inheritance_certificate: "სამკვიდრო მოწმობა (ასლი)",
  kyc_will: "ანდერძი (ასლი)",
  kyc_bankAccountStatement:
    "საბანკო ამონაწერი, სადაც ფიქსირდება თანხის მიღება ოჯახის წევრისაგან",
  kyc_otherOfficialDocument:
    "სხვა ოფიციალური დოკუმენტი, რომელიც ადასტურებს ოჯახის წევრის/წევრების შემოსავლებს",
  kyc_confirmationInvestment:
    "საინვესტიციო ან საბროკერო კომპანიის წერილობითი დასტური",
  kyc_idNumber: "პირადი ნომერი",
  kyc_greencard: "ხართ აშშ-ს მწვანე ბარათის მფლობელი?",
  kyc_us_taxpayer: "ხართ აშშ-ს გადასახადის გადამხდელი?",
  kyc_infoCounterparties: "ინფორმაცია საქმიანი პარტნიორების შესახებ",
  identification_header: "იდენტიფიკაცია",
  verification_header: "ვერიფიკაცია",

  private_information_header: "პირადი ინფორმაცია",
  about_services_header: "სერვისების შესახებ",
  private_information_subheader: "პირადი და ფინანსური დეტალები",
  account_created_header: "ანგარიში შექმნილია",
  account_created_subheader: "თქვენი ანგარიში შექმნილია",
  procredit_bank: "პროკრედიტ ბანკი",
  avatar_desc: "უნდა იყო სრულწლოვანი საქართველო მოქალაქე",
  account_desc: "პირადობის მოწმობა, ბინადრობის მოწმობა ან პასპორტი",
  hour_desc: "დრო 10 წუთი",
  enter_information: "შეიყვანე მონაცემები",
  info_about_opening_account:
    "ანგარიშის გახსნა შეუძლია ფიზიკურ პირს, საქართველოს მოქალაქის პირადობის მოწმობით, პასპორტით, ან მუდმივი ბინადრობის მოწმობით",
  agreement_remote_processing:
    "ვეთანხმები დისტანციურად <button>მონაცემების დამუშავების პირობებს </button>",
  terms_and_agreement: "ვადასტურებ <button>ხელშეკრულების პირობებს</button>",
  marketing_purpose_consent:
    "ვეთანხმები <button>მარკეტინგული მიზნებისათვის მონაცემების დამუშავებას</button>",
  already_have_account_header: "შენ უკვე გაქვს ანგარიში პროკრედიტ ბანკში",
  already_have_account_info:
    "თუ გადავიწყდა პაროლი აღადგინე შენი მონაცემები ან დაუკავშირდი კონტაქტ ცენტრს : *2222 ან + 995 322 222 222",
  authorization: "ავტორიზაცია",
  confirm_with_code: "დაადასტურე კოდით",
  code_has_been_sent: "კოდი გაგზავნილია",
  one_time_code: "ერთჯერადი კოდი",
  resend_code: "თავიდან გაგზავნა",
  bog: "საქართველოს ბანკი",
  tbc: "თიბისი ბანკი",
  credo: "კრედო ბანკი ",
  liberty: "ლიბერთი ბანკი ",
  choose_verification_method: "აირჩიე ვერიფიკაციის მეთოდი",
  another_bank: "სხვა ბანკით",
  another_bank_desc:
    "გაიარე ვერიფიკაცია სხვა ბანკის მეშვეობით 1 წუთში, სადაც გაქვს გახსნილი ანგარიში",
  choose_bank: "აირჩიე ბანკი",
  with_procredit: "პროკრედიტ ბანკით",
  with_procredit_desc:
    "გაიარე ბიომეტრიული ვერიფიკაცია პირადობის დამადასტურებელი საბუთით  5 წუთში",
  code_sens_for_registered_bank:
    "კოდი გაგზავნილია {{bank}} რეგისტრირებულ ნომერზე",
  i_agree: "გავეცანი",
  remote_data_processing_header:
    "დისტანციურად მონაცემების დამუშავების პირობები",
  terms_and_agreements_header: "ხელშეკრულების პირობები",
  marketing_consent_header: "მარკეტინგული მიზნებისათვის მონაცემების დამუშავება",
  sending: "იგზავნება",
  tax_residency_question: "გაქვს სხვა ქვეყნის გადამხდელის სტატუსი?",
  select_country: "აირჩიე ქვეყანა",
  enter_tax_code: "შეიყვანე საგადასახადო კოდი",
  add_country: "დაამატე ქვეყანა",
};
